export default __webpack_public_path__ + "static/media/superhero.8151c615.png";